import React, { Fragment, useState, useEffect } from 'react'
import { Col, Row, Card, CardBody } from 'reactstrap';
import { useQuatation } from '../../hooks/quoter/useQuatation'
import './QuoteStyle.css';
import 'animate.css';
import { ModalRepeatProfile } from '../../components/workOrders/ModalRepeatProfile';
import Select, { components } from 'react-select';
import { Button } from 'primereact/button';

import { IndexHederQuoter } from './componentsQuoter/IndexHederQuoter';
import '../quoter/styleQuoters/styleBodyQuoter.css'
import { GeneralInformation } from './seccionsQuoter/GeneralInformation';
import { TableQuoter } from './seccionsQuoter/TableQuoter';
import { IndexSidebarQuoter } from './componentsQuoter/IndexSidebarQuoter';
import { TableListSearchQuoter } from './seccionsQuoter/TableListSearchQuoter';
import { IndexFooterQuoterClinics } from './componentsQuoter/IndexFooterQuoterClinics';
import { CustomAlertDialogGlobal } from '../alertDialog/CustomAlertDialogGlobal';
import { ModalViewExamsQuoter } from './ModalViewExamsQuoter';
import { DialogPreviewPdf } from './DialogPreviewPdf';
import { ToastAletGlobal } from '../alertDialog/ToastAletGlobal';

export const IndexQuoterClinics = () => {

    const {
        // ? DIALOG QUOTER
        modalTitle, modalRepeatProfile, modalViewExamsP, toggleModalViewExams, toggleRepeatProfile,

        // ? VALUE
        observations, listQuoterTest, name, paternal_surname, maternal_surname, email,
        handleInputChange, totalW, subTotalW, totalTaxesW,
        examProfileState, viewExamsProfile, viewButtons, validationsRepeat,

        // ? QUOTER METHODS
        handleSelectExamChange, deleteExamProfile, handleCheckUrgent, handleCheckSpecimen,
        handleViewExamsProfile, saveCreate, sentPdf, phone, validationsSG, handleChangePercentage, lab,

        // ? CONFIGURATION QUOTER
        itemsTree, treeviewRef,

        // ? CONFIGURATION TYPE CLIENT 
        handleChangeTypeClient, chekTypeClient, id_agreement, listAgreement, handleSelectValues, loadingQuoter, number_format,

        // ? CONFIGURATION SEARCH QUOTER
        dataQuoter, handleFilterValues, date_ini, date_end, searchQuotes, downdloadQuoter, handleMouseEnter, handleMouseLeave, isHovered,
        showPreview, pdfPreviewUrl, handleOpenPreview, setPdfPreviewUrl, setShowPreview,
        loadingDownloadId, loadingPreviewId, handleSearch, exportExcel, loadingQuoterFilter,

        // ? CONFIGURATION PRELOADED
        listPreloaded, id_preloaded_discount, validatePreloadedDiscount, activeIndex, setActiveIndex, loading, progress, totalDiscountW,

        // ? CONFIGURATION HEADER
        viewDetailQuoter, handleViewQuoter, handleClosedQuoter,
        viewIndication, handleViewIndications, handleClosedIndications, loadingCreate, viewQuoter, loadingSend,
        removePreloadedDiscount,

        //? SEARCH QUOTER
        setSelectedCompany, selectedCompany, clearQuotationTests, resetQuotationForAgreement,

        //? FOOTER DISCOUNT
        handleApplyDiscount, loadingDiscount,

        //? BUTTONS FOOTER
        handleNewQuotation, activeView, goToListQuoter, setActiveView, confirmNewQuotation,

        //? ALERT GLOBAL
        requestChangeType, showAlert, cancelTabChange, confirmTabChange,

        showNewQuotationAlert, confirmNewQuotationAlert, cancelNewQuotationAlert,

        showDuplicateAlert,
        duplicateMessage,
        closeDuplicateExamAlert,

        //? ALERT IT DOES NOT EXIST IN THE AGREEMENT
        showInfoAlert, duplicateTitle,

        //? CUSTOM ALERT GLOBAL
        customAlert,

        //? TOAST ALERT
        showToast,
        toastType,
        toastTitle,
        toastMessage,
        showToastAlert,
        closeToastAlert,


    } = useQuatation();
    // console.log("🤖 dataQuoter", dataQuoter);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);
    const [rightPanelOpen, setRightPanelOpen] = useState(false);
    const url_helen = localStorage.getItem("url_helen");

    // const [activeView, setActiveView] = useState(0);

    // ? CLEAR INPUT
    const CustomClearIndicator = (props) => {
        return (
            <components.ClearIndicator {...props}>
                <Button
                    size="sm"
                    onClick={props.clearValue}
                    className="custom-clear-button"
                >
                    <i className="pi pi-tag" style={{ marginRight: '5px' }}></i>
                    Quitar
                </Button>
            </components.ClearIndicator>
        );
    };

    const newQuotationItems = [
        {
            label: "Particular",
            icon: "pi pi-user",
            command: () => confirmNewQuotation(1)
        },
        {
            label: "Empresa",
            icon: "pi pi-building",
            command: () => confirmNewQuotation(3)
        }
    ];

    return (
        <Fragment>
            <div className="pos-container">
                {
                    activeView === 0 && (
                        <Card style={{
                            marginBottom: '15px',
                            background: 'linear-gradient(135deg, #235e81 0%, #09385b 100%)',
                            border: 'none',
                            boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                        }} className='container-global-zoom'>
                            <CardBody style={{ padding: '18px 25px' }}>
                                <div className="d-flex align-items-center justify-content-between">
                                    <div className="d-flex align-items-center">
                                        <div style={{
                                            width: '50px',
                                            height: '50px',
                                            borderRadius: '12px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            marginRight: '15px'
                                        }}>
                                            <img alt="flask" className="img-fluid text-info mr-2" src={require("../../assets/images/quoter/quoter-clinics.svg")} style={{ width: "60px", height: "60px" }} />
                                        </div>
                                        <div>
                                            <h4 className="mb-1" style={{ color: '#fff', fontWeight: 700, fontSize: '20px', textAlign: "justify" }}>
                                                Cotizaciones de Estudios Clínicos
                                            </h4>
                                            <small style={{ color: 'rgba(255,255,255,0.85)', fontSize: '14px' }}>
                                                <i className="fa fa-info-circle mr-1"></i>
                                                Generación y gestión de cotizaciones de servicios clínicos, con inclusión de estudios y perfiles personalizados
                                            </small>
                                        </div>
                                    </div>

                                </div>
                            </CardBody>
                        </Card>
                    )}
                <header className="pos-header">
                    <IndexHederQuoter
                        {
                        ...{

                            setSelectedCompany, selectedCompany, handleSelectExamChange, url_helen,
                            handleChangeTypeClient, chekTypeClient, activeView, setActiveView, handleSelectValues,
                            listQuoterTest, clearQuotationTests, viewQuoter, requestChangeType,
                            rightPanelOpen,
                            setRightPanelOpen,
                            resetQuotationForAgreement
                        }
                        }
                    />
                </header>


                {/* BODY */}
                <div className="pos-body">
                    <div className="pos-main">
                        {
                            activeView === 0 ? (
                                 <div className="pos-main-scroll">
                                    <TableListSearchQuoter
                                        {...{
                                            isHovered,
                                            exportExcel,
                                            handleSearch,
                                            date_ini,
                                            date_end,
                                            searchQuotes,
                                            handleFilterValues,
                                            handleMouseEnter,
                                            handleMouseLeave,
                                            dataQuoter,
                                            loadingQuoterFilter,
                                            downdloadQuoter,
                                            loadingDownloadId,
                                            handleOpenPreview,
                                            loadingPreviewId,
                                        }}
                                    />
                                    <br />
                                </div>

                            ) : (

                                <>
                                    {
                                        isMobile ? (
                                            <div className="quoter-mobile-layout">

                                                <GeneralInformation
                                                    {...{
                                                        name,
                                                        paternal_surname,
                                                        maternal_surname,
                                                        email,
                                                        phone,
                                                        observations,
                                                        handleInputChange,
                                                        viewQuoter,
                                                        selectedCompany,
                                                        chekTypeClient,
                                                        validationsSG
                                                    }}
                                                />

                                                <Row>
                                                    <Col sm="12">
                                                        <TableQuoter
                                                            {...{
                                                                listQuoterTest,
                                                                deleteExamProfile,
                                                                number_format,
                                                                handleCheckUrgent,
                                                                handleViewExamsProfile,
                                                                viewQuoter
                                                            }}
                                                        />
                                                    </Col>
                                                </Row>

                                            </div>
                                        ) : (
                                            <>
                                                <div className="quoter-mobile-layout">

                                                    <GeneralInformation
                                                        {...{
                                                            name,
                                                            paternal_surname,
                                                            maternal_surname,
                                                            email,
                                                            phone,
                                                            observations,
                                                            handleInputChange,
                                                            viewQuoter,
                                                            selectedCompany,
                                                            chekTypeClient,
                                                            validationsSG
                                                        }}
                                                    />

                                                </div>

                                                <div className="pos-main-scroll">

                                                    <Row>
                                                        <Col sm="12">
                                                            <TableQuoter
                                                                {...{
                                                                    listQuoterTest,
                                                                    deleteExamProfile,
                                                                    number_format,
                                                                    handleCheckUrgent,
                                                                    handleViewExamsProfile,
                                                                    viewQuoter
                                                                }}
                                                            />
                                                        </Col>
                                                    </Row>

                                                </div>
                                            </>
                                        )
                                    }
                                </>

                            )
                        }

                    </div>

                    {
                        activeView !== 0 && (
                            <>
                                <aside className={`pos-sidebar ${rightPanelOpen ? "open" : ""} ${(loadingCreate || viewQuoter) ? "screen-disabled" : ""}`}>
                                    <div
                                        className="sidebar-hamburger right icon-toggle"
                                        onClick={() => setRightPanelOpen(false)}
                                    >
                                        <i className="fa fa-bars f-18"></i>
                                    </div>

                                    <div className="sidebar-content pt-0">

                                        <IndexSidebarQuoter
                                            {...{
                                                selectedCompany,
                                                itemsTree,
                                                treeviewRef,
                                                viewQuoter,
                                                observations,
                                                handleInputChange


                                            }}
                                        />

                                    </div>

                                </aside>


                            </>

                        )

                    }

                </div>

                <IndexFooterQuoterClinics
                    {
                    ...{

                        //? DISCOUNT
                        id_preloaded_discount, listPreloaded, removePreloadedDiscount, CustomClearIndicator,
                        loadingDiscount, handleApplyDiscount,

                        //? BREAKDOWN
                        number_format, subTotalW, totalDiscountW, totalTaxesW, totalW,

                        //? ACTIONS 
                        loadingCreate, loadingSend, sentPdf, loadingDownloadId, downdloadQuoter,
                        goToListQuoter, newQuotationItems, saveCreate,

                        //? DATA
                        listQuoterTest, handleSelectValues, chekTypeClient,

                        //? OTHERS
                        activeView, viewQuoter,
                    }
                    }
                />
                <CustomAlertDialogGlobal
                    visible={customAlert.visible}
                    mode={customAlert.mode}
                    type={customAlert.type}
                    title={customAlert.title}
                    message={customAlert.message}
                    buttonText={customAlert.buttonText}
                    cancelText={customAlert.cancelText}
                    onAccept={customAlert.onAccept}
                    onCancel={customAlert.onCancel}
                />

                <ModalViewExamsQuoter
                    {
                    ...{ modalViewExamsP, toggleModalViewExams, viewExamsProfile, handleViewExamsProfile }
                    }
                />

                <DialogPreviewPdf
                    {
                    ...{
                        showPreview, pdfPreviewUrl, setPdfPreviewUrl, setShowPreview
                    }
                    }
                />
                <ToastAletGlobal
                    visible={showToast}
                    type={toastType}
                    title={toastTitle}
                    message={toastMessage}
                    onClose={closeToastAlert}
                />

            </div>

        </Fragment >
    )
}